import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "core/store";
import { ReopenReducerType } from "./reducer";

const reopenReducer = (state: RootState): ReopenReducerType => state.reopen;

export const reopenShowHeaderSelector = createSelector(reopenReducer, (state) => state.showHeader);

export const reopenEndStepSelector = createSelector(reopenReducer, (state) => state.endSteps);
